import { render, staticRenderFns } from "./NNumberInput.vue?vue&type=template&id=1c32a6c4&scoped=true&"
import script from "./NNumberInput.vue?vue&type=script&lang=js&"
export * from "./NNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c32a6c4",
  null
  
)

export default component.exports